import { doPostMessage } from "../../core/services/MessageService";
import { subscribeMessage } from "../services/WindowMessage"


/**
 * @typedef {object} DoPostWindowMessge
 * @property {(key: string, value: any) => void} doPostMessage
 */


/**
 * 
 * @param {string} key 
 * @param {(any | null) => void} cb 
 * @returns {() =>void} unSubcribe
 */
export const useSubcribeWindowMessage = (key, cb) => {
    const unsub = subscribeMessage(key, cb)
    return unsub;
}

/**
 * 
 * @returns {DoPostWindowMessge}
 */
export const useDoPostWindowMessage = () => {
    return {
        doPostMessage: (key, value) => {
            doPostMessage(key, value);
        }
    }
}